import React, { useEffect, useState } from 'react';
import { Image } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { useSelector } from 'react-redux';

const sliderSettings = {
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1
};

const ListingDetailsMedia = ({ images }) => {
  const { restURI } = useSelector(state => state.config);

  let slider1;
  let slider2;
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  }, [slider1, slider2]);

  return (
    <div className="position-relative h-sm-100 overflow-hidden">
      {images.length === 1 && (
        <Image
          fluid
          className="fit-cover w-sm-100 h-sm-100 rounded"
          src={`${restURI}/files/${images[0].id}`}
        />
      )}
      {images.length > 1 && (
        <>
          <div className="product-slider">
            <Slider
              {...sliderSettings}
              asNavFor={nav2}
              ref={slider => (slider1 = slider)}
              className="slick-slider-arrow-inner"
            >
              {images.map(img => (
                <Image
                  fluid
                  rounded
                  className="fit-cover"
                  src={`${restURI}/files/${img.id}`}
                  alt={img.fileName}
                  key={img.id}
                />
              ))}
            </Slider>
          </div>
          <Slider
            slidesToShow={images.length > 5 ? 4 : images.length}
            asNavFor={nav1}
            ref={slider => (slider2 = slider)}
            swipeToSlide={true}
            focusOnSelect={true}
            centerMode={true}
            arrows={false}
            className="slick-slider-arrow-inner mt-1 mr-n1"
          >
            {images.map(img => (
              <div className="pe-1 outline-none" key={img.id}>
                <Image
                  fluid
                  rounded
                  className="cursor-pointer fit-cover w-sm-100 h-sm-50"
                  src={`${restURI}/files/${img.id}`}
                  alt={img.fileName}
                />
              </div>
            ))}
          </Slider>
        </>
      )}
    </div>
  );
};

ListingDetailsMedia.propTypes = {
  images: PropTypes.array.isRequired
};

export default ListingDetailsMedia;
